/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-11-04 10:45:36
 */

import React, { useEffect, useState } from 'react'
import { useSize } from 'ahooks'
import lock from '../../../images/photo_lock.png'
import ContactUS from '../../components/ContactUS'
import viewLimitSample1 from '../images/view_limit_sample_1.jpg'
import viewLimitSample2 from '../images/view_limit_sample_2.jpg'
import qiweiQrcode from '../images/qiwei_qrcode.png'
import { useAppSelector } from '../../../app/hooks'

/**
 * 卡点行内容
 * 1st Div，撑开整行，relative布局，作为整体容器
 * 2nd Div，sticky布局，避免跟随横向滚动，sticky距左边126px，留出固定列空间（固定列宽度110px + 当前列paddingLeft 16px）
 * 3rd Div，绝对定位，内容容器，距左边-126px，补位到固定列左侧
 * @returns React.ReactNode
 */
const GroupPhotoViewLimitRow = ({
  handleSensorClickItem
}: {
  handleSensorClickItem: (clickItem: string, restProperties?: any) => void
}) => {
  const fixedColumnWidth = 110
  const fixedColumnPaddingLeft = 16
  const stickyLeft = fixedColumnWidth + fixedColumnPaddingLeft
  const rowHeight = 105
  const kvConfig = useAppSelector((state) => state.main.config)
  const size = useSize(() => document.querySelector('.ant-table-content'))

  if (!size) return null

  return (
    <div style={{ position: 'relative', height: rowHeight * 2 }}>
      <div
        style={{
          width: size?.width ?? 0,
          height: rowHeight * 2,
          borderLeft: '1px solid #e8e8e8',
          position: 'sticky',
          top: 0,
          left: stickyLeft,
          zIndex: 2 // 层级在固定列（zIndex = 1）之上，覆盖固定列阴影样式
        }}
      >
        <div
          style={{
            width: '100%',
            height: rowHeight * 2,
            position: 'absolute',
            top: 0,
            left: 0 - stickyLeft,
            fontWeight: 'bold',
            backgroundColor: 'rgb(255, 255, 255)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 20,
              left: 0,
              width: 110,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '40px',
              filter: 'blur(5px)'
            }}
          >
            <div
              className="photo-thumbnail"
              style={{ backgroundImage: `url(${viewLimitSample1})` }}
            ></div>
            <div
              className="photo-thumbnail"
              style={{ backgroundImage: `url(${viewLimitSample2})` }}
            ></div>
          </div>
          <img
            src={qiweiQrcode}
            alt="qiweiQrcode"
            style={{ width: '170px', height: '170px' }}
          />
          <div
            style={{
              marginTop: '20px',
              marginLeft: '20px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}
          >
            <img
              src={lock}
              alt="lock"
              style={{ width: '19px', height: '23px' }}
            />
            <div
              style={{ fontSize: '20px', color: '#9A6516', marginTop: '10px' }}
            >
              团队人数已超上限，请联系商务人员开通企业版
              <p style={{ color: '#D25F00' }}>
                电话：
                {kvConfig.team_member_oversize_call_Phone || '13699662891'}
              </p>
            </div>
            <div
              style={{ fontSize: '20px', color: '#9A6516', marginTop: '20px' }}
            >
              <p>也可扫码添加【专属企微客服】</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GroupPhotoViewLimitRow
